export default __webpack_public_path__ + "static/media/sponsor-lutron.dd0c97d7.jpeg";